<section class="callback d-flex align-items-center">
  <div class="container">
    <p class="display-6 text-white text-center">{{ 'AZURE_CALLBACK.TITLE' | translate }}</p>
    <mat-card appearance="outlined" class="mat-elevation-z4">
      <mat-card-content>
        <ngx-spinner
          bdColor="rgba(0, 0, 0, 0)"
          name="azure-callback"
          size="medium"
          type="line-scale"
          color="#e0b310"
          [fullScreen]="false"
        ></ngx-spinner>
        @if (error$ | async) {
          <div class="d-flex align-items-center justify-content-center error-container">
            <mat-icon class="error-icon" fontSet="material-icons-outlined">error_outline</mat-icon>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
</section>
